<template>
  <div class="certification-info">
    <el-form :label-width="labelWidth">
      <el-form-item label="证件照片">
        <el-image :src="srcOne"></el-image>
      </el-form-item>
      <el-form-item label="签约抓拍">
        <el-image :src="srcTwo"></el-image>
      </el-form-item>
      <el-form-item label="客户姓名">
        <p>{{name}}</p>
      </el-form-item>
      <el-form-item label="手机号">
        <p>{{phone}}</p>
      </el-form-item>
      <el-form-item label="证件号">
        <p>{{number}}</p>
      </el-form-item>
      <el-form-item label="出生日期">
        <p>{{birthday}}</p>
      </el-form-item>
      <el-form-item label="地址">
        <p>{{address}}</p>
      </el-form-item>
      <!-- <el-form-item label="认证方式">
        <p>{{type}}</p>
      </el-form-item> -->
      <el-form-item label="认证时间">
        <p>{{time}}</p>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import CertificationService from '@/io/certification.js';

  export default {
    name: 'CertificationInfo',
    props: {
      id: {
        type: Number,
        default: null
      },
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initDatas();
          }
        },
        immediate: true
      }
    },
    data() {
      return {
        srcOne: '',
        srcTwo: '',
        name: '',
        phone: '',
        number: '',
        birthday: '',
        address: '',
        type: '',
        time: ''
      }
    },
    methods: {
      initDatas() {
        CertificationService.info(this.id).then(res => {
          this.srcOne = res.data.identity_attachment_data.attachment_access_url;
          this.srcTwo = res.data.contract_attachment_data.attachment_access_url;
          this.name = res.data.contract_customer_identity_name;
          this.phone = res.data.contract_customer_phone;
          this.number = res.data.contract_customer_identity_num;
          this.birthday = res.data.contract_customer_identity_birthday;
          this.address = res.data.contract_customer_identity_address;
          this.type = res.data.contract_type === 1 ? '一体机' : '小程序';
          this.time = res.data.contract_date;
        }).catch(() => {});
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';

  .certification-info {
    .el-image {
      width: 100px;
      height: 100px;
    }
  }
</style>